// Platform helpers for keyboard-shortcut hints.
// macOS uses ⌘ (Cmd); Windows/Linux use Ctrl.
export const isMac =
  typeof navigator !== 'undefined' &&
  /Mac|iPhone|iPod|iPad/i.test(
    navigator.userAgentData?.platform || navigator.platform || navigator.userAgent || ''
  )

// Single modifier-key label, e.g. for a standalone keycap.
export const MOD_KEY = isMac ? '⌘' : 'Ctrl'

// Combined hint for the command palette, e.g. "⌘K" / "Ctrl+K".
export const CMDK_HINT = isMac ? '⌘K' : 'Ctrl+K'
